import React from "react";
import { Wrapper, Content } from "./Knoppie.styles";
import { Link } from "react-router-dom";


const Knoppie = ({callback,switchOn,nommer,clickable,tafels,message,colorone,colortwo,list}) =>(
<Wrapper>
    <div class="tafels">
    <Content onClick={callback} switchOn = {switchOn} clickable={clickable} nommer={nommer} colorone={colorone} colortwo={colortwo} list={list}>
        
        {clickable?(
            <Link to='/:Game' state={{tafelnrs: tafels, aantalvrae:10, colorone:colorone, colortwo:colortwo}}>
                {nommer}
            </Link>
            
        ):
        (message?(<div>{nommer} {message}</div>):(<div>{nommer}</div>))
        
    }
   
    </Content>
   </div>
</Wrapper>


);

export default Knoppie;